module.exports = __webpack_public_path__ + "static/media/ethereum.6594b16f.png";